var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandPayloadStyleWhite = function SvgBrandPayloadStyleWhite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11.144 0 11 6.612v12.551l-8.283 4.792v-12.55L2.848 4.8zM10.3 13.465v9.794L2 18.266z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandPayloadStyleWhite);
export { ForwardRef as ReactComponent };